import React, { useEffect, useRef, useState } from "react";
// interface
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import Loader from "components/Loader";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import LoadingIconWithText from "components/LoadingIconWithText";
import * as url from "../../../api/urls"
import { ucSetConfigValue } from "../../../redux/actions"
import { Link } from "react-router-dom";
import classnames from "classnames";
import AppSimpleBar from "components/AppSimpleBar";
import { FixedSizeList as List } from 'react-window';
import FormInput from "components/FormInput";
import TextBox from "components/TextBox";
import { Switch, FormControlLabel, useMediaQuery } from '@mui/material';
import { HexColorPicker } from 'react-colorful';
import InputColor from 'react-input-color';
import { Autocomplete, TextField } from '@mui/material';
import Select, { components, useStateManager } from 'react-select';
import { MemberRole, tb_WpTagMaster, tb_WpTagMasterMember } from "../../../redux/workplace/wpTypes";
import { Const } from "const";
import axios from 'axios';
import BackHeaderIcon from "components/BackHeaderIcon";
import PermConfig2 from "components/PermConfig2";
import BackgroundQueue from "components/BackgroundQueue";
import WpTagPermReport from "./WpTagPermReport";
import { UserTypes } from "../../../api/auth";

interface DataSettingPageProps {
  // basicDetails: BasicDetailsTypes;
}
const DataSettingPage = ({ /*basicDetails*/ }: DataSettingPageProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Settings,
    (state: any) => state.Profile2,
    (st, p2) => ({
      userConfig: st.userConfig,
      ucLoadUserConfigLoading: st.ucLoadUserConfigLoading,
      isAdmin: p2.isAdmin,
      userType: p2.userType,
      isItSupport: p2.isItSupport,
    })
  );
  const { isAdmin, userType, isItSupport } = useAppSelector(storeData);
  const allowEdit = isAdmin || (isItSupport === true && userType === UserTypes.Employee);
  const isDark = Utils.IsDarkTheme();
  const api = new APIClient

  const [tagCats, setTagCats] = useState<any[]>([]);
  const [tagKeys, setTagKeys] = useState<any[]>([]);
  const [tagForMemDdl, setTagForMemDdl] = useState<any[]>([]);
  const [loadingCat, setLoadingCat] = useState<boolean>(false);
  const [loadingTagKey, setLoadingTagKey] = useState<boolean>(false);
  const [selCat, setSelCat] = useState<string>("");
  const [selTagId, setSelTagId] = useState<number>(-1);
  const [filterTagKey, setFilterTagKey] = useState<string>("");

  const isMobile = useMediaQuery(`(max-width:${Const.BREAKPOINT_MD - 0.02}px)`);
  const [mobileScreen, setMobileScreen] = useState<"CAT" | "KEY" | "DETAIL">("CAT");


  // bumped on every cat/tag click, so a late API response for an older click is ignored
  const detailSeqRef = useRef<number>(0);
  const tagKeySeqRef = useRef<number>(0);

  const EMPTY_CAT: EditingData["category"] = { categoryOld: "", category: "", name: "", seq: "99", faIcon: "", faColor: "#FF0000", bgColor: "#AAAAAA", enabled: true, usedCount: 0, lastSync: "", tagCount: 0 };
  const catToEditing = (cat: string) => {
    const c = tagCats.find(t => t.category == cat);
    return c ? { ...c, categoryOld: c.category } : null;
  }

  // back to "no category selected": empty tag list, detail closed
  const fnClearSelCat = () => {
    detailSeqRef.current++;
    tagKeySeqRef.current++;
    setSelCat("");
    setSelTagId(-1);
    setTagKeys([]);
    setLoadingTagKey(false);
    setEditingData(prev => ({ ...prev, type: "NONE", category: EMPTY_CAT }));
  }

  const fnLoadCat = async (fromClick: boolean) => {
    try {
      fnClearSelCat();
      setMobileScreen("CAT");
      setLoadingCat(true);
      api.fnPostForm(url.WP_LOAD_TAG_CAT, {})
        .then(rs => {
          setTagCats(rs);
          setLoadingCat(false);
          // console.log('cat list:', rs);
        })
        .catch(e2 => {
          Utils.HandleException(e2, fromClick);
          setLoadingCat(false);
        });
    } catch (e) {
      Utils.HandleException(e, fromClick)
    }
  }

  type DATA_TYPE = "NONE" | "CAT" | "TAG";

  type EditingData = {
    type: DATA_TYPE,
    isNewMode: boolean,
    category: { categoryOld: string, category: string, name: string, seq: string, faIcon: string, faColor: string, bgColor: string, enabled: boolean, usedCount: number, lastSync: string, tagCount: number, },
    tag: tb_WpTagMaster | null
  }

  const [editingData, setEditingData] = useState<EditingData>({
    type: "NONE",
    isNewMode: true,
    category: EMPTY_CAT,
    tag: null
  });


  useEffect(() => {
    fnLoadCat(false);
  }, []);

  useEffect(() => {
    loadTagForMemDdl();
  }, []);

  const loadTagForMemDdl = async () => {
    try {
      api.fnPost(url.WP_LOAD_TAG_FOR_MEM, {})
        .then(rs => {
          rs.forEach((t: any) => t.value = t.tagId);
          setTagForMemDdl(rs)
          // console.log('tagForMemDdl:', rs);
        })
        .catch(ex => Utils.HandleException(ex, false));
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }


  const timerStatusRef = useRef<NodeJS.Timeout | null>(null);
  const [computStatus, setComputStatus] = useState<any>({});
  useEffect(() => {
    let isMounted = true;

    // We define the logic here so it can be called recursively
    const loadStatus = async () => {
      try {
        const api = new APIClient();
        // Use 'await' so the code pauses until the API responds
        const rs = await api.fnPostForm(url.WP_TAG_CAT_FOR_FILTER_2_COMPUTE_GET_STATUS, {});
        setComputStatus(rs);
      } catch (e) {
        console.error("API Error:", e);
      } finally {
        // ONLY if the component is still visible, wait 1s then call again
        if (isMounted) {
          timerStatusRef.current = setTimeout(loadStatus, 5000);
        }
      }
    };

    // Kick off the first call
    loadStatus();

    return () => {
      isMounted = false; // Stop any pending state updates
      if (timerStatusRef.current) {
        clearTimeout(timerStatusRef.current);
      }
    };
  }, []);

  const fnReloadStat = async () => {
    try {
      const api = new APIClient();
      // Use 'await' so the code pauses until the API responds
      const rs = await api.fnPostForm(url.WP_TAG_CAT_FOR_FILTER_2_COMPUTE_GET_STATUS, {});
      setComputStatus(rs);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [isComputePermFromQueue, setIsComputePermFromQueue] = useState<boolean>(false);
  const fnComputePermFromQueue = async (event: any) => {
    const holdCtrl = event.ctrlKey;
    const msg = (holdCtrl ? "ระบบจะคำนวณสิทธิ์ใหม่ ของคิวทั้งหมด (อาจใช้เวลา)" : "ระบบจะคำนวณสิทธิ์ของ tag จากคิวจำนวน 10 คิว") + "<br/>ดำเนินการต่อหรือไม่<br/><span class='text-warning'>**ระบบมีการคำนวณอัตโนมัติอยู่แล้ว**<span>";
    const rs = await Utils.SweetConfirm(msg);
    if (!rs.isConfirmed) return;

    setIsComputePermFromQueue(true);
    try {
      const api = new APIClient();
      const rs = await api.fnPostForm(url.WP_TAG_CAT_FOR_FILTER_2_COMPUTE_FROM_QUEUE, { computeAll: holdCtrl });
      setComputStatus(rs);
    } catch (e) {
      Utils.HandleException(e, true);
    }
    setIsComputePermFromQueue(false);
  }

  interface ContentHeadProps {
    showReport: boolean;
    onShowReportClick(): void;
  }

  const ContentHead = ({ showReport, onShowReportClick }: ContentHeadProps) => {
    const contentTitle = "ข้อมูล TAG ในระบบ Work Place";

    return (
      <div className="d-flex justify-content-between align-items-center " style={{ borderBottom: "dashed gray 1px" }}>
        {/* <div className="flex-shrink-0 d-block d-md-none me-2">
          <Link
            to="#"
            // onClick={onHeaderClick}
            className={classnames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
          >
            <i className="bx bx-chevron-left align-middle"></i>
          </Link>
        </div> */}
        <div>
          <BackHeaderIcon headerOf="setting"></BackHeaderIcon>
          <div className="flex-grow-1 overflow-hidden ">
            <div className="d-flex align-items-center">
              <div
                className={classnames(
                  "flex-shrink-0",
                  "chat-user-img",
                  "align-self-center",
                  "me-0",
                  "ms-0",
                )}
              >
                <i className="text-muted me-3 fas fa-tags fz-15"></i>
              </div>
              <div className="flex-grow-1 overflow-hidden">
                <h6 className="text-truncate mb-0 font-size-18">
                  <Link to="#" className="user-profile-show text-reset">
                    {contentTitle}
                  </Link>
                  {/* <BackgroundQueue/> */}
                  <button className={"ms-2 btn2 btn2-" + (showReport ? "" : "outline-") + "primary"} onClick={onShowReportClick}>ดูรายงาน</button>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div>
          <span className="text-info me-1">คิว <span className="text-warning hover hand" onClick={fnReloadStat} title={`Queue Perm Config = ${computStatus.queuePermConfig ?? 0}, Queue Perm Tag = ${computStatus.queuePermTag ?? 0}`}>{computStatus.queuePermConfig ?? 0}-{computStatus.queuePermTag ?? 0}</span>
            &nbsp;รอคำนวณสิทธิ์
            [ล่าสุด {Utils.GetDMYHHMM(computStatus.queuePermTagLastDate)}]
          </span>
          {isAdmin && (
            <span onClick={(e) => isComputePermFromQueue ? null : fnComputePermFromQueue(e)}>
              {!isComputePermFromQueue && (<i className="fas fa-calculator text-info hover hand" title="กด ctrl ค้าง เพื่อคำนวณใหม่ทั้งหมด (อาจใช้เวลา)"></i>)}
              {isComputePermFromQueue && (<LoadingIconWithText loadingText={""} />)}
            </span>
          )}
          {/* <LoadingIconWithText loadingText={""}/> */}
        </div>
      </div>
    );
  }

  const Title: React.FC<{ type: DATA_TYPE, title: string, showAdd: boolean, rightExtra?: React.ReactNode }> = ({ type, title, showAdd, rightExtra }) => (
    <div className="btn btn-secondary mb-2 d-flex justify-content-between align-items-center">
      <span>{title}</span>
      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
        {rightExtra}
        {type == "CAT" && (<><i className="fas fa-redo-alt text-warning" onClick={() => fnLoadCat(true)}></i>&nbsp;</>)}
        {type == "TAG" && (<><i className="fas fa-redo-alt text-warning" onClick={() => onLoadTagKey(selCat)}></i>&nbsp;</>)}
        {(showAdd && allowEdit && type == "CAT") && (<i className="fas fa-plus-circle text-warning" onClick={() => { onClickCat(""); setMobileScreen("DETAIL"); }}></i>)}
        {(showAdd && allowEdit && type == "TAG") && (<i className="fas fa-plus-circle text-warning" onClick={() => { onClickTag(-1); setMobileScreen("DETAIL"); }}></i>)}
      </div>
    </div>
  )

  const onClickCat = async (cat: string, toggle: boolean = false) => {
    try {
      if (toggle && cat != "" && cat == selCat) { // re-click active cat = unselect
        fnClearSelCat();
        return;
      }
      const seq = ++detailSeqRef.current;
      setSelCat(cat);
      onLoadTagKey(cat);
      if (cat == "") { // add new
        setEditingData(prev => ({
          ...prev, type: "CAT", isNewMode: true, category: {
            category: "", name: "", seq: "99", categoryOld: "", enabled: true, faColor: "#FF0000", bgColor: "#AAAAAA", faIcon: "fab fa-angellist", lastSync: "", tagCount: 0, usedCount: 0
          }
        }));
      } else { // load from db
        const fromList = catToEditing(cat);
        if (fromList) setEditingData(prev => ({ ...prev, type: "CAT", isNewMode: false, category: fromList }));
        api.fnPostForm(url.WP_LOAD_TAG_CAT, { category: cat })
          .then(rs => {
            if (seq != detailSeqRef.current) return;
            if (rs && rs.length == 1) {
              // console.log('cat:', rs[0]);
              setEditingData(prev => ({
                ...prev, type: "CAT", isNewMode: false, category: { ...rs[0], categoryOld: rs[0].category }
              }));
            }
          })
          .catch(e2 => Utils.HandleException(e2, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const fnFillMember = (members: tb_WpTagMasterMember[]) => {
    const newData = [...members];
    newData.forEach(e => {
      e.uid = Utils.GetUniqueId();
      // e.memberName = tagForMemDdl.find((t:any) => t.tagId == e.memberTagId)
      //e.memberName = '<i class="fas fa-ad"></i>' + (tagForMemDdl.find((t: any) => t.tagId === e.memberTagId)?.label || "");
    });

    const MAX_MEMBER_ROW = 30;
    while (newData.length < MAX_MEMBER_ROW) {
      newData.push({
        uid: Utils.GetUniqueId(),
        parentTagId: -1,
        memberTagId: -1,
        parentTagKeyId: "",
        memberRole: MemberRole.Follower,
        rowCompute: 0,
        isManual: true,
        remark: "",
        memberName: "",
      });
    }

    return newData;
  }

  const [isUserRoleOwner, setIsUserRoleOwner] = useState<boolean>(false);

  // tagCategory = category of the clicked tag (list may hold tags from all categories); new tag (-1) always uses selCat
  const onClickTag = async (tag: number, tagCategory?: string) => {
    try {
      const cat = tag == -1 ? selCat : (tagCategory ?? selCat);
      if (!cat) {
        alert('กรุณาเลือกประเภทก่อน');
      } else {
        // console.log('tag = ' + tag);
        const seq = ++detailSeqRef.current;
        setSelTagId(tag);
        const catEditing = catToEditing(cat);
        // onLoadTagKey(cat);
        if (tag == -1) { // add new
          setIsUserRoleOwner(true);
          setEditingData(prev => ({
            ...prev, type: "TAG", isNewMode: true, category: catEditing ?? prev.category, tag: {
              tagId: -1,
              category: cat, name: "", tagKeyId: "", enabled: true, usedCount: 0, syncDate: null,
              members: fnFillMember([])
            }
          }));
        } else { // load from db
          setIsUserRoleOwner(false);
          if (catEditing) setEditingData(prev => ({ ...prev, category: catEditing }));
          api.fnPostForm(url.WP_LOAD_TAG_FOR_EDIT2, { tagId: tag })
            .then(rs => {
              if (seq != detailSeqRef.current) return;
              // console.log('WP_LOAD_TAG_FOR_EDIT:', rs);
              setIsUserRoleOwner(rs.canEditMember);
              rs.members = fnFillMember(rs.members);
              const rsCat = catToEditing(rs.category);
              setEditingData(prev => ({
                ...prev, type: "TAG", isNewMode: false, category: rsCat ?? prev.category, tag: rs
              }));
            })
            .catch(e2 => Utils.HandleException(e2, true));
        }
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickViewTagMemberOf = async () => {
    try {
      api.fnPostForm(url.WP_LOAD_TAG_MEMBER_OF, { tagId: selTagId })
        .then(rs => {
          const tdBase = "text-align:left; padding:4px 8px; border-bottom:1px solid rgba(128,128,128,0.3);";
          const tdSeqBase = "text-align:center; padding:4px 8px; border-bottom:1px solid rgba(128,128,128,0.3);";
          const td = `style="${tdBase}"`;
          const tdSeq = `style="${tdSeqBase}"`;
          const list = [...(rs ?? [])].sort((a: any, b: any) => (b.enabled ? 1 : 0) - (a.enabled ? 1 : 0));
          const rows = list.map((r: any, idx: number) => {
            const strike = r.enabled ? "" : "text-decoration:line-through;";
            const tdRow = `style="${tdBase}${strike}"`;
            const tdSeqRow = `style="${tdSeqBase}${strike}"`;
            return `<tr>
              <td ${tdSeqRow}>${idx + 1}</td>
              <td ${tdRow}>
                <span style="display:inline-flex; align-items:center; gap:6px;">
                  <span class="${r.faIcon ?? ""}" style="width:16px; text-align:center; color:${r.faColor ?? ""};"></span>
                  <span>${r.catName ?? ""}</span>
                </span>
              </td>
              <td ${tdRow}>${r.tagName ?? ""}</td>
            </tr>`;
          }).join("");
          const catIcon = editingData.category.faIcon ?? "";
          const catColor = editingData.category.faColor ?? "";
          const tagName = editingData.tag?.name ?? "";
          const header = `<div style="text-align:left; margin-bottom:8px;"><span class="${catIcon}" style="color:${catColor};"></span>&nbsp;<b>${tagName}</b> เป็นสมาชิกใน ${list.length} tag ดังนี้...</div>`;
          const html = `
            ${header}
            <div style="max-height:300px; overflow-y:auto;">
              <table style="width:100%; border-collapse:collapse;">
                <thead><tr><th ${tdSeq}>ลำดับ</th><th ${td}>หมวด</th><th ${td}>Tag</th></tr></thead>
                <tbody>${rows || `<tr><td ${td} colspan="3">ไม่พบข้อมูล</td></tr>`}</tbody>
              </table>
            </div>
          `;
          Utils.SweetAlert(html);
        })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickViewTagNoGroup = async () => {
    try {
      const category = editingData.category?.category;
      api.fnPostForm(url.WP_LOAD_TAG_NO_GROUP, { category })
        .then(rs => {
          const tdBase = "text-align:left; padding:4px 8px; border-bottom:1px solid rgba(128,128,128,0.3);";
          const tdSeqBase = "text-align:center; padding:4px 8px; border-bottom:1px solid rgba(128,128,128,0.3);";
          const td = `style="${tdBase}"`;
          const tdSeq = `style="${tdSeqBase}"`;
          const list = [...(rs ?? [])];
          const rows = list.map((r: any, idx: number) => `<tr>
              <td ${tdSeq}>${idx + 1}</td>
              <td ${td}>${r.name ?? ""}</td>
            </tr>`).join("");
          const catIcon = editingData.category.faIcon ?? "";
          const catColor = editingData.category.faColor ?? "";
          const catName = editingData.category.name ?? editingData.category.category ?? "";
          const header = `<div style="text-align:left; margin-bottom:8px;"><span class="${catIcon}" style="color:${catColor};"></span>&nbsp;<b>${catName}</b> มี tag ที่ไม่มีกลุ่ม ${list.length} รายการ ดังนี้...</div>`;
          const html = `
            ${header}
            <div style="max-height:300px; overflow-y:auto;">
              <table style="width:100%; border-collapse:collapse;">
                <thead><tr><th ${tdSeq}>ลำดับ</th><th ${td}>Tag</th></tr></thead>
                <tbody>${rows || `<tr><td ${td} colspan="2">ไม่พบข้อมูล</td></tr>`}</tbody>
              </table>
            </div>
          `;
          Utils.SweetAlert(html);
        })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onLoadTagKey = async (cat: string) => {
    try {
      setSelTagId(-1);
      setEditingData(prev => ({ ...prev, type: "NONE" }));
      const seq = ++tagKeySeqRef.current;
      // no category selected = search all categories (needs filter text)
      if ((cat && cat != "") || filterTagKey.trim() != "") {
        setLoadingTagKey(true);
        api.fnPostForm(url.WP_LOAD_TAG_KEY, { category: cat ?? "", filter: filterTagKey })
          .then(rs => {
            if (seq != tagKeySeqRef.current) return;
            setTagKeys(rs);
            setLoadingTagKey(false);
          })
          .catch(e1 => {
            if (seq != tagKeySeqRef.current) return;
            Utils.HandleException(e1, true);
            setLoadingTagKey(false);
          });
      } else {
        setTagKeys([]);
        setLoadingTagKey(false);
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  // useEffect(() => {
  //   onLoadTagKey();
  // }, [selCat]);

  const NewLine: React.FC<{}> = ({ }) => { return (<><br /></>) }


  const cssTableContainer: React.CSSProperties = { maxHeight: "400px", overflow: "auto" }
  const cssTable: React.CSSProperties = { borderCollapse: "collapse", width: "auto", }
  const cssTh: React.CSSProperties = { position: "sticky", top: "0", backgroundColor: "var(--bs-chat-primary-bg)" }
  const cssTrh: React.CSSProperties = { height: "40px" }

  const onSaveData = async () => {
    try {
      if (editingData.type == "CAT") {
        if (editingData.category.category.trim() == "") {
          alert('กรุณาใส่รหัส');
          return;
        }
        // const parm = { ...editingData.category, categoryOld: editingData.isNewMode ? "" : editingData.category.categoryOld };
        const parm = {
          categoryOld: editingData.isNewMode ? "" : editingData.category.categoryOld,
          category: editingData.category.category,
          faIcon: editingData.category.faIcon,
          faColor: editingData.category.faColor ?? "#FF0000",
          bgColor: editingData.category.bgColor ?? "#FFFFFF",
          enabled: editingData.category.enabled,
          seq: editingData.category.seq,
          name: editingData.category.name ?? editingData.category.category,
        }
        //console.log(parm);
        api.fnPostForm(url.WP_SAVE_TAG_CAT, parm)
          .then(rs => {
            // let newData = tagCats;
            // const idx = newData.findIndex(t => t.category == rs.category);
            // console.log('idx = ' + idx);
            // if (idx >= 0){
            //   newData[idx] = rs;
            // }else{
            //   newData.push(rs);
            // }
            // console.log(newData);
            // setTagCats(newData);
            // console.log('rs:', rs);
            setTagCats(prev => {
              const idx = prev.findIndex(t => t.category == parm.categoryOld);
              if (idx >= 0) {
                const updated = [...prev];
                updated[idx] = rs;
                return updated;
              }
              return [...prev, rs];
            });
            onClickCat(rs.category);
          })
          .catch(e2 => Utils.HandleException(e2, true));
      } else if (editingData.type == "TAG") {
        if (!editingData.tag?.name) {
          alert('กรุณาระบุ ชื่อ tag');
          return;
        }

        // console.log(editingData.tag);

        // axios.post('/wp-save-tag-key', editingData.tag, { withCredentials: true })
        //   .then(response => {
        //     console.log("Saved successfully:", response.data);
        //   })
        //   .catch(error => {
        //     console.error("Error saving tag:", error);
        //   });

        api.fnPostBody(url.WP_SAVE_TAG_KEY, editingData.tag)
          .then(rs => {
            setTagKeys(prev => {
              const idx = prev.findIndex(t => t.tagId == rs.tagId);
              if (idx >= 0) {
                const updated = [...prev];
                updated[idx] = rs;
                return updated;
              }
              return [...prev, rs];
            });
            onClickTag(rs.tagId, rs.category);
            if ((editingData.tag?.tagId ?? 0) <= 0) { // add new then increase count
              setTagCats(prev => prev.map(t => t.category == rs.category ? { ...t, tagCount: (t.tagCount ?? 0) + 1 } : t));
            }
            loadTagForMemDdl();
          })
          .catch(e2 => Utils.HandleException(e2, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onDeleteData = async () => {
    try {
      Utils.SweetConfirm("ยืนยันลบข้อมูล ที่เลือก")
        .then(rs => {
          if (rs.isConfirmed) {
            if (editingData.type == "CAT") {
              api.fnPostForm(url.WP_DEL_TAG_CAT, { categoryOld: editingData.category.categoryOld })
                .then(rs => {
                  setTagCats(prev => prev.filter(t => t.category != editingData.category.categoryOld));
                  setEditingData(prev => ({ ...prev, type: "NONE" }));
                })
                .catch(e3 => Utils.HandleException(e3, true));
            } else if (editingData.type == "TAG") {
              api.fnPostForm(url.WP_DEL_TAG_KEY, { tagId: editingData.tag?.tagId })
                .then(rs => {
                  setTagKeys(prev => prev.filter(t => t.tagId != editingData.tag?.tagId));
                  setEditingData(prev => ({ ...prev, type: "NONE" }));
                  setTagCats(prev => prev.map(t => t.category == editingData.tag?.category ? { ...t, tagCount: (t.tagCount ?? 0) - 1 } : t));
                  loadTagForMemDdl();
                })
                .catch(e3 => Utils.HandleException(e3, true));
            }
          }
        })
        .catch(e1 =>
          Utils.HandleException(e1, true)
        );
      if (editingData.type == "CAT") {

      }

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const optionsX = [
    { value: 1, label: 'John Doe' },
    { value: 2, label: 'Jane Smith' },
    { value: 3, label: 'Michael Johnson' },
    // ... more
  ];

  const CustomOption = (props: any) => (
    <components.Option {...props}>
      <div className="hover" style={{ color: props.data.faColor, backgroundColor: props.data.bgColor }} ><i className={props.data.faIcon} style={{ marginRight: 8 }}></i>{props.data.label}</div>
    </components.Option>
  );

  const CustomSingleValue = (props: any) => (
    <components.SingleValue {...props}>
      <i className={props.data.faIcon} style={{ marginRight: 8 }}></i>{props.data.label}
    </components.SingleValue>
  );

  const lightThemeStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: '#fff',
      borderColor: '#ccc',
      color: '#000',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#999',
      },
      padding: '0em'
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f0f0f0' : '#fff',
      color: state.isSelected ? '#fff' : '#333',
      '&:active': {
        backgroundColor: '#007bff',
      },
      padding: '0em'
    }),
    singleValue: (base: any) => ({
      ...base,
      color: '#000',
      padding: '0em'
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: '#fff',
      padding: '0em'
    }),
    input: (base: any) => ({
      ...base,
      color: '#000', // Ensure the search text is visible in light theme
    }),
  };

  const darkThemeStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: '#333',
      borderColor: '#444',
      color: '#adb5bd',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#666',
      },
      padding: '0em'
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#555' : '#333',
      color: state.isSelected ? '#adb5bd' : '#ccc',
      '&:active': {
        backgroundColor: '#007bff',
      },
      padding: '0em'
    }),
    singleValue: (base: any) => ({
      ...base,
      color: '#adb5bd',
      padding: '0em'
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: '#333',
      padding: '0em'
    }),
    input: (base: any) => ({
      ...base,
      color: '#adb5bd', // Ensure the search text is visible in dark theme
    }),
  };

  const currentStyles = Utils.IsDarkTheme() ? darkThemeStyles : lightThemeStyles;

  //useEffect(() => { console.log('editingData:', editingData); }, [editingData]);

  const canEditTagHeader = () => {
    if (editingData?.category?.lastSync) return false;
    return allowEdit;
    // return true;
  }

  const isReserveCat = (cat: string = editingData?.category?.categoryOld) => {
    const r1 = cat == Const.WP_CAT_CUS;
    const r2 = cat == Const.WP_CAT_EMP;
    const r3 = cat == Const.WP_CAT_SUP;
    const r4 = cat == Const.WP_CAT_EXU;
    return r1 || r2 || r3 || r4;
  }

  const onTagDetailChange = (type: "TAG_NAME" | "REF_KEY" | "MEMBER" | "MEMBER_ROLE" | "REMARK", uid: string | null, value: any) => {
    try {
      // console.log(value);
      if (type == "TAG_NAME") {
        setEditingData(prev => ({ ...prev, tag: { ...prev.tag, name: value } }));
      } else if (type == "REF_KEY") {
        setEditingData(prev => ({ ...prev, tag: { ...prev.tag, tagKeyId: value } }));
      } else if (type == "MEMBER" || type == "MEMBER_ROLE" || type == "REMARK") {
        setEditingData(prev => ({
          ...prev,
          tag: {
            ...prev.tag,
            members: prev.tag?.members?.map(t => t.uid == uid ? ({
              ...t,
              memberRole: type == "MEMBER_ROLE" ? value : t.memberRole,
              remark: type == "REMARK" ? value : t.remark,
              memberTagId: type == "MEMBER" ? (value?.tagId ?? -1) : t.memberTagId,
              memberName: type == "MEMBER" ? (value?.label ?? "") : t.memberName,
            }) : t)
          }
        }));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const fnTest = () => {
    setTagCats(prev => prev.map(t => t.category == "TME" ? { ...t, tagCount: t.tagCount - 1 } : t));
  }

  const [isMoveCatToggle, setIsMoveCatToggle] = useState<boolean>(false);
  const [isMoveCatProcess, setIsMoveCatProcess] = useState<boolean>(false);
  const ddlMoveToCatRef = useRef<HTMLSelectElement>(null);
  const fnMoveCat = async () => {
    try {
      const tagId = editingData?.tag?.tagId;
      if (!tagId) {
        alert("ยังไม่ได้เลือก tag");
        return;
      }
      const catCode = ddlMoveToCatRef.current?.value;
      const catName = ddlMoveToCatRef.current?.options[ddlMoveToCatRef.current?.selectedIndex].text; // selected text
      if (!catCode) {
        alert("ยังไม่ได้เลือกหมวด");
        return;
      }


      const parm = {
        tagId,
        moveToCateogry: catCode,
        checkOnly: false
      }
      setIsMoveCatProcess(true);
      Utils.SweetConfirm(`คุณต้องการย้าย tag ที่เลือก ไปยังหมวด ${catName} ใช่หรือไม่?`).then(rs => {
        setIsMoveCatProcess(false);
        if (rs.isConfirmed) {
          const api = new APIClient();
          api.fnPostForm(url.WP_TAG_MASTER_MOVE, parm)
            .then(rs => {
              alert('ย้ายสำเร็จ');
              fnLoadCat(true);
              onClickCat(catCode);
              setEditingData(prev => ({ ...prev, type: "NONE" }));
              setIsMoveCatToggle(false);
            })
            .catch(e2 => {
              Utils.HandleException(e2, true);
            });

        }
      });


    } catch (e) {
      Utils.HandleException(e, true);
    }

  }

  const [isComputeMemInPostByTagId, setIsComputeMemInPostByTagId] = useState<boolean>(false);
  const fnComputeMemInPostByTagId = async (tagId: number) => {
    console.log('tagId:' + tagId);
    if (tagId <= 0) {
      alert('No Tag ID');
      return;
    }
    Utils.SweetConfirm("ปุ่มนี้ ไว้สำหรับคำนวณสมาชิกในโพสใหม่ ใช้ในกรณีที่มีการเปลี่ยนแปลงสมาชิกใน tag แล้วสมาชิกในโพสไม่เปลี่ยนตาม (ปกติสมาชิกในโพสจะเปลี่ยนตามอัตโนมัติ ทำงานเบื้องหลัง)<br/>หากทิ้งไว้ซักพักแล้วสมาชิกยังไม่เปลี่ยน ให้มากดปุ่มนี้ซ้ำได้<br/>ต้องการดำเนินการต่อหรือไม่?")
      .then(rs => {
        if (rs.isConfirmed) {
          try {
            const api = new APIClient;
            setIsComputeMemInPostByTagId(true);
            api.fnPostForm(url.WP_COMPUTE_MEM_IN_POST_BY_TAG_ID, { tagId: tagId })
              .then(rs => { setIsComputeMemInPostByTagId(false); })
              .catch(er => {
                setIsComputeMemInPostByTagId(false);
                Utils.HandleException(er, true);
              })
          } catch (e) {
            Utils.HandleException(e, true);
          }
        }
      });
  }

  const [showReport, setShowReport] = useState<boolean>(false);
  const onShowReportClick = () => {
    setShowReport(prev => !prev);
  }

  const [loadingPerm, setLoadingPerm] = useState<boolean>(false);
  const [apiPermResult, setApiPermResult] = useState<any>();
  const fnReloadPerm = async () => {
    const api = new APIClient();
    const parm = {
      companyName: null,
      divisionName: null,
      departmentName: null,
      positionName: null,
      employee: null,
      catagories: null
    }
    setLoadingPerm(true);
    api.fnPostForm(url.WP_TAG_CAT_FOR_FILTER2ALLOW_REPORTBYEMP, { parm })
      .then(rs => {
        setApiPermResult(rs);
        setLoadingPerm(false);
      })
      .catch(ex => {
        const msg = Utils.GetMessageFromExecption(ex);
        if (msg && msg.toLocaleLowerCase().includes('timeout')) {
          // nothing 
        } else {
          Utils.HandleException(ex, true);
        }
        setLoadingPerm(false);
      });
  }

  useEffect(() => {
    fnReloadPerm();
  }, []);

  return (
    <div className="general-right-container">
      {/* <button onClick={fnTest}>test</button> */}
      {/* <div className="p-2"> */}
      <div className="mb-3">
        <ContentHead showReport={showReport} onShowReportClick={onShowReportClick} />
      </div>
      {showReport && (
        // <div className="dsp-container">
        <WpTagPermReport reportPermApiResult={apiPermResult} onReloadPerm={fnReloadPerm} loadingPerm={loadingPerm}></WpTagPermReport>
        // </div>
      )}
      {!showReport && (
        <div className="dsp-container">

          <div className={classnames("dsp-div-cat", { "d-none": isMobile && mobileScreen != "CAT" })} style={{ position: "relative" }}>
            <Title type="CAT" title="ประเภท" showAdd={true} rightExtra={isMobile && (
              <i className="fas fa-search text-warning" title="ค้นหา tag ทุกหมวด" onClick={() => { fnClearSelCat(); setMobileScreen("KEY"); }}></i>
            )} />
            {loadingCat && (<Loader />)}
            <div style={{ display: "flex", flexDirection: "column", padding: "0px", gap: "4px", position: "relative" }}>
              {tagCats.map((item: any, index: number) =>
                // <button key={index} className="btn btn-sm btn-outline-secondary hover hand" onClick={() => alert('12')} style={{ color: item.faColor }}>
                //   <span className={item.faIcon ?? ""}></span>&nbsp;{item.category}
                // </button>
                <div key={index} className={classnames("dsp-cat hover hand d-flex justify-content-between align-items-center", { "dsp-active": selCat == item.category })} style={{ color: item.faColor, backgroundColor: item.bgColor }}
                  onClick={() => { const isUnselect = selCat == item.category; onClickCat(item.category, true); if (!isUnselect) setMobileScreen("KEY"); }}>
                  <div >
                    <span style={{ width: "18px" }} className={item.faIcon ?? ""}></span>&nbsp;{item.name ?? item.category}
                  </div>
                  {item.tagCount > 0 && (<span>{Utils.FormatNumber(item.tagCount, 0)}</span>)}
                </div>
              )}
            </div>
          </div>

          <div className={classnames("dsp-div-key", { "d-none": isMobile && mobileScreen != "KEY" })}>
            {isMobile && (
              <button className="btn btn-sm btn-outline-secondary mb-2" onClick={() => setMobileScreen("CAT")}><i className="fas fa-arrow-left"></i>&nbsp;ประเภท</button>
            )}
            <Title type="TAG" title="TAG" showAdd={!!selCat && !isReserveCat(selCat)} />
            <TextBox placeholder={selCat ? "ตัวกรอง " + (tagCats.find(t => t.category == selCat)?.name ?? selCat) : "ตัวกรองทุกหมวด"} style={{ padding: "4px", marginBottom: "6px" }} icon13css="fas fa-search" value={filterTagKey} onChange={(e) => setFilterTagKey(e.target.value)} onEnter13={() => onLoadTagKey(selCat)} />


            <AppSimpleBar className="dsp-simbar-key">
              {loadingTagKey && (<Loader />)}
              <div style={{ display: "flex", flexDirection: "column", padding: "0px", gap: "4px", position: "relative" }}>
                {tagKeys.map((item: any, index: number) => {
                  const itemCat = selCat ? null : tagCats.find(t => t.category == item.category); // show category only in all-category search
                  return (
                  <div key={index} className={classnames("dsp-cat hover hand d-flex justify-content-between align-items-center", { "dsp-active": selTagId == item.tagId, "disabled": !item.enabled })} onClick={() => { onClickTag(item.tagId, item.category); setMobileScreen("DETAIL"); }}>
                    <span>
                      {itemCat && (<span className={itemCat.faIcon ?? ""} style={{ width: "18px", color: itemCat.faColor }} title={itemCat.name ?? itemCat.category}></span>)}
                      {itemCat && (<>&nbsp;</>)}
                      {item.name}
                    </span>
                    {item.usedCount > 0 && (<span>{Utils.FormatNumber(item.usedCount, 0)}</span>)}
                  </div>
                  );
                })}
              </div>
            </AppSimpleBar>


          </div>
          <div className={classnames("dsp-div-member", { "d-none": isMobile && mobileScreen != "DETAIL" })}>
            {isMobile && (
              <button className="btn btn-sm btn-outline-secondary mb-2" onClick={() => setMobileScreen(selCat || editingData.type == "TAG" ? "KEY" : "CAT")}><i className="fas fa-arrow-left"></i>&nbsp;กลับ</button>
            )}
            <Title type="NONE" title="รายละเอียด" showAdd={false} rightExtra={<>
              {editingData.type == "CAT" && editingData.category?.categoryOld == Const.WP_CAT_EMP && (
                <button className="btn btn-sm btn-outline-warning" onClick={onClickViewTagNoGroup}>{editingData.category?.name ?? editingData.category?.category} ที่ไม่มีกลุ่ม</button>
              )}
              {editingData.type == "TAG" && editingData.category?.categoryOld == Const.WP_CAT_EMP && (
                <button className="btn btn-sm btn-outline-warning" onClick={onClickViewTagMemberOf}>ดู tag ที่เป็นสมาชิก</button>
              )}
            </>} />
            <div>

              {/* CATEGORY DETAILS */}
              {editingData.type == "CAT" && (
                <>
                  <div style={{ maxWidth: "600px", display: editingData.type == "CAT" ? "" : "none" }} className="">
                    <div className="row">
                      <div className="col-6 " >
                        <div className="row">
                          <div className="col pb-2" style={{ backgroundColor: "#f2f2f2" }}>
                            <div >
                              ตัวอย่าง
                              <NewLine />
                              <div className={classnames("dsp-cat hover hand d-flex justify-content-between align-items-center")} style={{ color: editingData.category.faColor, backgroundColor: editingData.category.bgColor }} >
                                <span>
                                  <span className={editingData.category.faIcon}></span>&nbsp;{editingData.category.name ?? editingData.category.category}
                                </span>
                                {/* <span>99</span> */}
                              </div>
                            </div>
                          </div>
                          <div className="col pb-2" style={{ backgroundColor: "#2e2e2e" }}>
                            <div >
                              ตัวอย่าง
                              <NewLine />
                              <div className={classnames("dsp-cat hover hand d-flex justify-content-between align-items-center")} style={{ color: editingData.category.faColor, backgroundColor: editingData.category.bgColor }} >
                                <span>
                                  <span className={editingData.category.faIcon}></span>&nbsp;{editingData.category.name ?? editingData.category.category}
                                </span>
                                {/* <span>99</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="row">
                          <div className="col-4">
                            สี
                            <NewLine />
                            <div className="d-flex justify-content-between">
                              <input className="" type="color" style={{ border: "none" }} disabled={!allowEdit} value={editingData.category.faColor} onChange={(e) => setEditingData(prev => ({ ...prev, category: { ...prev.category, faColor: e.target.value } }))}></input>
                              <input className="" type="color" style={{ border: "none" }} disabled={!allowEdit} value={editingData.category.bgColor} onChange={(e) => setEditingData(prev => ({ ...prev, category: { ...prev.category, bgColor: e.target.value } }))}></input>

                            </div>
                          </div>
                          <div className="col-8">
                            จำนวนข้อมูล
                            <input type="text" className="form-control p-1" readOnly={true} value={editingData.category.tagCount.toString()} />
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="row">
                      <div className="col">
                        รหัส (3 ตัวอักษร)
                        <TextBox className="form-control p-1" maxLength={3} value={editingData.category.category}
                          onChange={(e) => setEditingData(prev => ({ ...prev, category: { ...prev.category, category: e.target.value } }))}
                          readOnly={!allowEdit || editingData.category.category == Const.WP_CAT_CUS || editingData.category.category == Const.WP_CAT_EMP || editingData.category.category == Const.WP_CAT_SUP || editingData.category.category == Const.WP_CAT_EXU}
                        />
                      </div>
                      <div className="col">
                        Icon
                        <TextBox className="form-control p-1" readOnly={!allowEdit} value={editingData.category.faIcon} onChange={(e) => setEditingData(prev => ({ ...prev, category: { ...prev.category, faIcon: e.target.value } }))} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        ชื่อ
                        <TextBox className="form-control p-1" readOnly={!allowEdit} value={editingData.category.name} onChange={(e) => setEditingData(prev => ({ ...prev, category: { ...prev.category, name: e.target.value } }))}></TextBox>
                      </div>
                      <div className="col-3">
                        ใช้งาน
                        <NewLine />
                        <FormControlLabel control={<Switch checked={editingData.category.enabled} readOnly={!allowEdit} onChange={(e) => setEditingData(prev => ({ ...(prev || {}), category: { ...(prev.category || {}), enabled: e.target.checked } }))} />}
                          label={editingData.category.enabled ? "ใช้งาน" : "ระงับ"} />
                      </div>
                      <div className="col-3">
                        ลำดับ
                        <TextBox className="form-control p-1" readOnly={!allowEdit} value={editingData.category.seq} onChange={(e) => setEditingData(prev => ({ ...prev, category: { ...prev.category, seq: e.target.value } }))}></TextBox>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        จำนวนถูก tag
                        <input type="text" className="form-control p-1" readOnly={true} value={editingData.category.usedCount} />
                      </div>
                      <div className="col">
                        Sync ล่าสุด
                        <input type="text" className="form-control p-1" readOnly={true} value={editingData.category.lastSync ?? ""} />
                      </div>
                    </div>
                    <div className="row pt-2">
                      {allowEdit && (
                        <div className="col" style={{ display: "flex", gap: "5px", justifyContent: "space-between" }}>
                          {(isReserveCat()) ? (<div></div>) : (<><button className="btn btn-sm btn-danger" onClick={onDeleteData}>&nbsp;&nbsp;ลบ&nbsp;&nbsp;</button></>)}

                          <div>
                            <button className="btn btn-sm btn-warning" onClick={() => { setEditingData(prev => ({ ...prev, type: "NONE" })); setMobileScreen("KEY"); }}>ยกเลิก</button>
                            &nbsp;
                            <button className="btn btn-sm btn-primary" onClick={onSaveData}>บันทึก</button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {editingData.category.category && (
                    <>
                      <br />
                      สิทธิ์ <span className="text-secondary"></span>
                      <PermConfig2 permTitle={"หมวดหมู่ " + editingData.category.name} permName={"WP-TAG-CAT-" + editingData.category.category} defaultAllow={true} canEdit={allowEdit} cssContainer="data-setting-page-perm-config"></PermConfig2>
                    </>
                  )}
                </>
              )}

              {/* TAG DETAILS */}
              {editingData.type == "TAG" && (
                <div style={{ display: editingData.type == "TAG" ? "" : "none" }} className="">
                  <div className="row" style={{}}>
                    <div className="col-8">
                      ชื่อ tag (id={editingData.tag?.tagId})&nbsp;&nbsp;&nbsp;
                      <FormControlLabel control={
                        <Switch checked={editingData.tag?.enabled ?? false}
                          onChange={(e) => setEditingData(prev => ({ ...(prev || {}), tag: { ...(prev.tag || {}), enabled: e.target.checked } }))} />
                      }
                        label={editingData.tag?.enabled ? "ใช้งาน" : "ระงับ"} />
                      <TextBox className="form-control p-1" value={editingData?.tag?.name ?? ""} readOnly={!canEditTagHeader()}
                        //onChange={(e) => setEditingData(prev => ({ ...prev, tag: { ...prev.tag, name: e.target.value } }))}
                        onChange={(e) => onTagDetailChange("TAG_NAME", "", e.target.value)}
                      ></TextBox>
                    </div>
                    <div className="col-4">
                      {/* Ref Key */}
                      <div style={{ paddingTop: "10px", height: "37px" }}>Ref Key</div>
                      <TextBox className="form-control p-1" value={editingData?.tag?.tagKeyId ?? ""} readOnly={!canEditTagHeader()}
                        // onChange={(e) => setEditingData(prev => ({ ...prev, tag: { ...prev.tag, tagKeyId: e.target.value } }))}
                        onChange={(e) => onTagDetailChange("REF_KEY", "", e.target.value)}
                      ></TextBox>
                    </div>
                  </div>
                  {(editingData?.category?.category !== Const.WP_CAT_EMP && editingData?.category?.category !== Const.WP_CAT_EXU) && (
                    <>
                      <AppSimpleBar style={{ maxHeight: "400px" }} >
                        <div className="row pt-2" >
                          <div className="col">
                            <div style={cssTableContainer}>
                              <table style={cssTable} >
                                <thead>
                                  <tr style={cssTrh}>
                                    <th style={cssTh}>สมาชิก</th>
                                    <th style={cssTh}>ประเภท</th>
                                    <th style={cssTh}>หมายเหตุ</th>
                                    <th style={cssTh}></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(editingData.tag?.members || []).map((mem: tb_WpTagMasterMember, key: number) => (
                                    <tr key={key}>
                                      <td style={{ minWidth: "280px" }}>
                                        <Select
                                          options={tagForMemDdl}
                                          onChange={(e) => onTagDetailChange("MEMBER", mem.uid, e)}
                                          styles={currentStyles}
                                          components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
                                          placeholder={""}
                                          value={mem.memberTagId == -1 ? null : tagForMemDdl.find(o => o?.tagId > 0 && o?.tagId === mem.memberTagId && (mem.memberTagId ?? -1) != -1)} // your selected value logic
                                          //value={{ value: mem.memberTagId, label: mem.memberName }}
                                          isClearable
                                          isDisabled={!allowEdit || !mem.isManual}
                                          menuPortalTarget={document.body}
                                        />
                                      </td>
                                      <td>
                                        <select className="form-control p-1" disabled={!allowEdit || !mem.isManual} onChange={(e) => onTagDetailChange("MEMBER_ROLE", mem.uid, e.target.value)} value={mem.memberRole?.toString()}>
                                          <option value={MemberRole.Owner}>Owner</option>
                                          <option value={MemberRole.Follower}>Follower</option>
                                          <option value={MemberRole.Observer}>Observer</option>
                                        </select>
                                      </td>
                                      <td><input type="text " className="form-control p-1" readOnly={!allowEdit || !mem.isManual} value={mem.remark ?? ""} onChange={(e) => onTagDetailChange("REMARK", mem.uid, e.target.value)}></input></td>
                                      <td>
                                        {mem.isManual && (
                                          <>
                                            {/* <i className="fas fa-plus-circle text-primary"></i>
                                    &nbsp;
                                    <i className="fas fa-minus-circle text-danger"></i> */}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </AppSimpleBar>
                      <div className="row pt-2" style={{}}>
                        {/* {(allowEdit || isUserRoleOwner) && ( */}
                        {(allowEdit /*|| isUserRoleOwner*/) && ( /*20251111 Change back not allow owner edit member */
                          <div className="col" style={{ display: "flex", gap: "5px", justifyContent: "space-between" }}>
                            <div>
                              {canEditTagHeader() && (
                                <div className="d-flex justify-content-left align-items-center" style={{ gap: "6px" }}>
                                  <button className="btn btn-sm btn-danger" onClick={onDeleteData}>&nbsp;&nbsp;ลบ&nbsp;&nbsp;</button>
                                  <button className={"btn btn-sm btn-" + (isMoveCatToggle ? "" : "outline-") + "warning"} onClick={() => setIsMoveCatToggle(prev => !prev)}><i className="fas fa-angle-double-right"></i> ย้ายหมวด</button>
                                  {isMoveCatToggle && (
                                    <>
                                      <select ref={ddlMoveToCatRef} style={{ padding: "5px" }}>
                                        {tagCats.map(cat => (<option key={cat.category} value={cat.category} >{cat.name}</option>))}
                                      </select>
                                      <i
                                        className={classnames("fa fz-14 ", {
                                          "text-primary hand fa-check-circle ": !isMoveCatProcess,
                                          "text-secondary fa-spinner fa-spin": isMoveCatProcess
                                        })}
                                        onClick={fnMoveCat}
                                      ></i>
                                    </>
                                  )}

                                  <button className="btn btn-sm btn-outline-warning" title="หากมีการเปลี่ยนสมาชิกใน tag ที่กำลังแก้ แต่ในโพสยังไม่เปลี่ยนตาม ให้กดปุ่มนี้เพื่อให้ระบบคำนวณใหม่ (อาจมีเวลาในการรอ ขึ้นอยู่กับปริมาณโพส)"
                                    onClick={() => isComputeMemInPostByTagId ? null : fnComputeMemInPostByTagId(editingData?.tag?.tagId ?? -1)}
                                    disabled={isComputeMemInPostByTagId}
                                  >
                                    {!isComputeMemInPostByTagId && (<i className="fas fa-user-cog"></i>)}
                                    {isComputeMemInPostByTagId && (<LoadingIconWithText loadingText={""} />)}
                                    {isComputeMemInPostByTagId ? (" กำลังคำนวณ") : (" คำนวณสมาชิกในโพสใหม่")}

                                  </button>
                                </div>
                              )}
                            </div>

                            <div>
                              <button className="btn btn-sm btn-warning" onClick={() => { setEditingData(prev => ({ ...prev, type: "NONE" })); setMobileScreen("KEY"); }}>ยกเลิก</button>&nbsp;
                              <button className="btn btn-sm btn-primary" onClick={onSaveData}>บันทึก</button>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {(editingData.tag?.tagId && editingData.tag?.tagId > 0) && (
                    <>
                      <br />
                      สิทธิ์ <span className="text-secondary"></span>
                      <PermConfig2 permTitle={editingData.category.name + "->" + editingData.tag?.name} permName={"WP-TAG-KEY-" + editingData.tag?.tagId} defaultAllow={true} canEdit={allowEdit} cssContainer="data-setting-page-perm-config-tag"></PermConfig2>
                    </>
                  )}
                </div>
              )}


            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataSettingPage;
